import { VincularAspectoPontoAcessoComponent } from "./components/vincularAspectoPontoAcesso/vincularAspectoPontoAcesso.component";
import { CadastroAspectoPropriedadeComponent } from "./components/cadastroAspectoPropriedade/cadastroAspectoPropriedade.component";
import { TabelaMatrizComponent } from "./components/tabelaMatriz/tabelaMatriz.component";
import { CriarRelatorioComponent } from "./config-relatorio/criar-relatorio/criar-relatorio.component";
import { BuscarExpurgoService } from "./components/caixa/buscarExpurgo/buscar-expurgo.service";
import { LocalDateTimePipeAuditoria } from "./components/caixa/auditoria-caixa/local-date-auditoria";
import { LocalDateTimestamp } from "./components/caixa/auditoria-caixa/local-date-timestamp";
import { LocalDateTimePipe3 } from "./components/caixa/listar-conteudos/local-date-conteudo";
import { DialogConfirmComponent } from "./components/dialog/dialog-confirm/dialog-confirm.component";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { LocalDateTimePipe } from "./service/produto/local-date-time";
import { LocalDateTimePipe2 } from "./components/caixa/pesquisa-caixa-avancada/local-date";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, Injectable } from "@angular/core";
import { RouterModule, Routes, CanActivate, Router } from "@angular/router";
import { TextMaskModule } from "angular2-text-mask";
import { MatDialogRef } from "@angular/material/dialog";
import { MatTableModule } from "@angular/material/table";
// ADF modules
import { AdfModule } from "./adf.module";
import { AuthGuardEcm, FormModule } from "@alfresco/adf-core";

// App components
import { AppComponent } from "./app.component";
import { HomeComponent } from "./components/home/home.component";
import { LoginComponent } from "./components/login/login.component";
import { DocumentlistComponent } from "./components/documentlist/documentlist.component";
import { IndexComponent } from "./components/index/index.component";
import { ClienteService } from "./service/cliente/cliente.service";
import { EnderecosComponent } from "./components/endereco-components/enderecos/enderecos.component";
import { AreasComponent } from "./components/cliente-components/areas/areas.component";
import { ClientesComponent } from "./components/cliente-components/clientes/clientes.component";
import { AreaService } from "./service/cliente/area.service";
import { EnderecoService } from "./service/endereco/endereco.service";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { TipoclienteService } from "./service/cliente/tipocliente.service";
import { TipoclienteComponent } from "./components/cliente-components/tipocliente/tipocliente.component";
import { RamoatividadeComponent } from "./components/cliente-components/ramoatividade/ramoatividade.component";
import { GrupoclienteComponent } from "./components/cliente-components/grupocliente/grupocliente.component";
import { IndicereajusteComponent } from "./components/cliente-components/indicereajuste/indicereajuste.component";
import { TiporeajusteComponent } from "./components/cliente-components/tiporeajuste/tiporeajuste.component";
import { FormsModule } from "@angular/forms";
import { GrupoclienteService } from "./service/cliente/grupocliente.service";
import { IndicereajusteService } from "./service/cliente/indicereajuste.service";
import { TiporeajusteService } from "./service/cliente/tiporeajuste.service";
import { RamoatividadeService } from "./service/cliente/ramoatividade.service";
import { ListaclientesComponent } from "./components/cliente-components/listaclientes/listaclientes.component";
import { RegiaoComponent } from "./components/endereco-components/regiao/regiao.component";
import { TipoenderecoComponent } from "./components/endereco-components/tipoendereco/tipoendereco.component";
import { ArmazemComponent } from "./components/endereco-components/armazem/armazem.component";
import { RegiaoService } from "./service/endereco/regiao.service";
import { ArmazemService } from "./service/endereco/armazem.service";
import { TipoenderecoService } from "./service/endereco/tipoendereco.service";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { DialogTipoClienteComponent } from "./components/cliente-components/tipocliente/dialog-tipo-cliente/dialog-tipo-cliente.component";
import { CreateClienteComponent } from "./components/cliente-components/clientes/create-cliente/create-cliente.component";
import { GrupoProdutoComponent } from "./components/produto-components/grupo-produto/grupo-produto.component";
import { GrupoProdutoService } from "./service/produto/grupo-produto.service";
import { ProdutoService } from "./service/produto/produto.service";
import { PrecoService } from "./service/produto/preco.service";
import { AplicabilidadeService } from "./service/produto/aplicabilidade.service";
import { ProdutoComponent } from "./components/produto-components/produto/produto.component";
import { SidenavComponent } from "./components/sidenav/sidenav.component";
import { ProdutosArquivadosComponent } from "./components/produto-components/produtos-arquivados/produtos-arquivados.component";
import { PaginationPrecoComponent } from "./components/pagination-preco/pagination-preco.component";
import { PrecoPadraoComponent } from "./components/produto-components/produto/preco-padrao/preco-padrao.component";
import { PrecificacaoComponent } from "./components/produto-components/precificacao/precificacao.component";
import { PrecoProdutoClienteService } from "./service/produto/preco-produto-cliente.service";
import { UnidadeGestoraComponent } from "./components/cliente-components/unidade-gestora/unidade-gestora.component";
import { DocmentlistService } from "./service/docmentlist.service";
import { AssinaturaEletronicaComponent } from "./components/assinatura-eletronica/assinatura-eletronica.component";
import { NgxLoadingModule } from "ngx-loading";

import { CentroCustoComponent } from "./components/cliente-components/centro-custo/centro-custo.component";
import { CentroCustoService } from "./service/cliente/centro-custo.service";
import { SidenavCaixaComponent } from "./components/sidenav-caixa/sidenav-caixa.component";
import { CaixaComponent } from "./components/caixa/caixa.component";
import { TipoCaixaComponent } from "./components/caixa/tipo-caixa/tipo-caixa.component";
import { TipoCaixaService } from "./service/caixa/tipo-caixa.service";
import { CaixaService } from "./service/caixa/caixa.service";
import { PermissoesService } from "./service/usuario/permissoes.service";
import { PermissaoComponent } from "./components/usuario/permissao/permissao.component";
import { AccessControlDirective } from "./directives/access-control.directive";
import { Erro403Component } from "./components/erro-pages/erro403/erro403.component";
import { Erro404Component } from "./components/erro-pages/erro404/erro404.component";
import { AuthGuard } from "./guards/auth.guard";
import { ConfigurarPermissaoComponent } from "./components/usuario/configurar-permissao/configurar-permissao.component";
import { GrupoPermissaoComponent } from "./components/permissions/grupo-permissao/grupo-permissao.component";
import { PermissionsService } from "./service/permission/permissions.service";
import { CreateGrupoPermissionComponent } from "./components/permissions/create-grupo-permission/create-grupo-permission.component";
import { MatPaginatorModule } from "@angular/material";
import { VincularEmpresaDialogComponent } from "./components/vincular-empresa-dialog/vincular-empresa-dialog.component";

import { ListagemPermissoesComponent } from "./listagem-permissoes/listagem-permissoes.component";
import { ConfigurarPermissoesComponent } from "./configurar-permissoes/configurar-permissoes.component";

import { NovoClienteComponent } from "./components/cliente-components/novo-cliente/novo-cliente.component";
import { ListaClientesPastaComponent } from "./lista-clientes-pasta/lista-clientes-pasta.component";
import { ConfigurarPastaComponent } from "./configurar-pasta/configurar-pasta.component";
import { ConfigurarPastaServiceService } from "./configurar-pasta-service.service";
import { VincularTipoClienteComponent } from "./vincular-tipo-cliente/vincular-tipo-cliente.component";
import { IncluirTipoDocumentalComponent } from "./incluir-tipo-documental/incluir-tipo-documental.component";
import { EditarAspectoComponent } from "./editar-aspecto/editar-aspecto.component";
import { IncluirUriAlfrescoComponent } from "./incluir-uri-alfresco/incluir-uri-alfresco.component";
import { VincularUriAlfrescoComponent } from "./vincular-uri-alfresco/vincular-uri-alfresco.component";
import { VincularUriAlfrescoDialogComponent } from "./vincular-uri-alfresco-dialog/vincular-uri-alfresco-dialog.component";
import { ImportarModeloComponent } from "./importar-modelo/importar-modelo.component";
import { EditGlobalTypesComponent } from "./components/edit-global-types/edit-global-types.component";
import { MatIconModule } from "@angular/material/icon";
import { IncludeUniquePermissionComponent } from "./include-unique-permission/include-unique-permission.component";
import { ListarCaixaComponent } from "./components/caixa/listar-caixa/listar-caixa.component";
import { DialogCodAlternativoComponent } from "./components/caixa/dialog-cod-alternativo/dialog-cod-alternativo.component";
import { TipoConteudoComponent } from "./components/caixa/tipo-conteudo/tipo-conteudo.component";
import { TipoConteudoService } from "./service/caixa/tipo-conteudo.service";
import { AdicionarConteudoComponent } from "./components/caixa/adicionar-conteudo/adicionar-conteudo.component";
import { ConteudoService } from "./service/caixa/conteudo.service";
import { EditarCaixaComponent } from "./components/caixa/editar-caixa/editar-caixa.component";
import { ConteudoEletronicoService } from "./service/caixa/conteudo-eletronico.service";
import { PesquisaCaixaAvancadaComponent } from "./components/caixa/pesquisa-caixa-avancada/pesquisa-caixa-avancada.component";
import { PesquisaConteudoAvancadaComponent } from "./components/caixa/pesquisa-conteudo-avancada/pesquisa-conteudo-avancada.component";
import { ListarConteudosComponent } from "./components/caixa/listar-conteudos/listar-conteudos.component";
import { ExibirConteudoCaixaComponent } from "./components/caixa/exibir-conteudo-caixa/exibir-conteudo-caixa.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { ListagemConteudoEletronicoComponent } from "./components/caixa/listagem-conteudo-eletronico/listagem-conteudo-eletronico.component";
import { ViewDocumentoEletronicoComponent } from "./components/caixa/view-documento-eletronico/view-documento-eletronico.component";
import { RelatorioCaixaComponent } from "./components/caixa/relatorio-caixa/relatorio-caixa.component";
import { RelatorioCaixasSelecionadasComponent } from "./components/caixa/relatorio-caixas-selecionadas/relatorio-caixas-selecionadas.component";
import { SidenavSolicitacaoComponent } from "./components/sidenav-solicitacao/sidenav-solicitacao.component";
import { AdicionarSolicitacaoComponent } from "./components/solicitacao/adicionar-solicitacao/adicionar-solicitacao.component";
import { SolicitacaoService } from "./service/solicitacao/solicitacao.service";
import { ListarSolicitacaoComponent } from "./components/solicitacao/listar-solicitacao/listar-solicitacao.component";
import { AuditoriaCaixaComponent } from "./components/caixa/auditoria-caixa/auditoria-caixa.component";
import { ListarSolicitacoesComponent } from "./components/solicitacao/listar-solicitacoes/listar-solicitacoes.component";
import { localDateTimePipe4 } from "./components/solicitacao/listar-solicitacao/local-date";
import { PesquisaAvancadaSolicitacaoComponent } from "./components/solicitacao/pesquisa-avancada-solicitacao/pesquisa-avancada-solicitacao.component";
import { ProcessarSolicitacaoComponent } from "./processar-solicitacao/processar-solicitacao.component";
import { DetalhesCaixaComponent } from "./detalhes-caixa/detalhes-caixa.component";
import { MultiplasOpcoesDialogComponent } from "./multiplas-opcoes-dialog/multiplas-opcoes-dialog.component";
import { AlocarRecipienteDialogComponent } from "./alocar-recipiente-dialog/alocar-recipiente-dialog.component";

import { ModuloComponent } from "./components/endereco-components/modulo/modulo.component";
import { ModuloService } from "./service/endereco/modulo.service";
import { TipoComponenteService } from "./service/endereco/tipo-componente.service";
import { TipoComponenteComponent } from "./components/endereco-components/tipo-componente/tipo-componente.component";
import { UnidadeComponent } from "./components/endereco-components/unidade/unidade.component";
import { UnidadeService } from "./service/endereco/unidade.service";
import { ComponenteComponent } from "./components/endereco-components/componente/componente.component";
import { ComponenteService } from "./service/endereco/componente.service";
import { ComponentesFilhosComponent } from "./components/endereco-components/componente/componentes-filhos/componentes-filhos.component";
import { AdicionarComponenteComponent } from "./components/endereco-components/componente/adicionar-componente/adicionar-componente.component";
import { GerarRgsComponent } from "./components/caixa/gerar-rgs/gerar-rgs.component";
import { RelatorioSolicitacaoComponent } from "./components/solicitacao/relatorio-solicitacao/relatorio-solicitacao.component";
import { TreeModule } from "angular-tree-component";
import { GraficoAlocacaoComponent } from "./grafico-alocacao/grafico-alocacao.component";
import { RecuperarCaixasComponent } from "./recuperar-caixas/recuperar-caixas.component";
import { DevolverCaixasComponent } from "./devolver-caixas/devolver-caixas.component";
import { ListaRgsComponent } from "./components/caixa/lista-rgs/lista-rgs.component";
import { CacheCodAlternativoService } from "./service/caixa/cache-cod-alternativo.service";
import { RelatorioPendenteRecuperacaoComponent } from "./recuperar-caixas/relatorio-pendente-recuperacao/relatorio-pendente-recuperacao.component";
import { RelatorioAuditoriaComponent } from "./components/caixa/auditoria-caixa/relatorio-auditoria/relatorio-auditoria.component";
import { GraficoComponenteDialogComponent } from "./grafico-componente-dialog/grafico-componente-dialog.component";
import { ControleComponent } from "./components/solicitacao/controle/controle.component";
import { ImprimirControleComponent } from "./components/solicitacao/imprimir-controle/imprimir-controle.component";
import { RelatorioControleComponent } from "./components/solicitacao/relatorio-controle/relatorio-controle.component";
import { DetalhesSolicitacaoComponent } from "./components/solicitacao/detalhes-solicitacao/detalhes-solicitacao.component";
import { DadosAutoriaComponent } from "./dados-autoria/dados-autoria.component";
import { RelatorioSolicitacaoRealocacaoComponent } from "./components/solicitacao/relatorio-solicitacao-realocacao/relatorio-solicitacao-realocacao.component";
import { DadosAutoriaService } from "./dados-autoria/dados-autoria.service";
import { DadosArquivisticosComponent } from "./components/dados-arquivisticos/dados-arquivisticos.component";
import { DadosArquivisticosService } from "./components/dados-arquivisticos/dados-arquivisticos.service";
import { TokenAssinadorComponent } from "./components/assinatura-eletronica/token-assinador/token-assinador.component";
import { TokenAssinadorService } from "./components/assinatura-eletronica/token-assinador/token-assinador.service";
import { ConfigRelatorioComponent } from "./config-relatorio/config-relatorio.component";
import { RelatorioService } from "./service/cliente/relatorio.service";
import { HeaderComponent } from "./components/header/header.component";
import { UnidadeGestoraService } from "./service/cliente/unidade-gestora.service";
import { DadosPessoaisComponent } from "./components/usuario/dados-pessoais/dados-pessoais.component";
import { DadosPessoaisService } from "./components/usuario/dados-pessoais/dados-pessoais.service";
import { UsersDocTypeComponent } from "./components/users-doc-type-dialog/users-doc-type.component";
import { NodeUserDialogComponent } from "./components/dialog/node-user-dialog/node-user-dialog.component";
import { ConfigParamsComponent } from "./components/config-params/config-params.component";
import { ParamsService } from "./service/cliente/params/params.service";
import { SecurityProfileService } from "./service/securityProfile/securityProfile.service";
import { ParamGroupDialogComponent } from "./components/dialog/param-group-dialog/param-group-dialog.component";
import { ParamTypeDialogComponent } from "./components/dialog/param-type-dialog/param-type-dialog.component";
import { IncluirPermissaoUserComponent } from "./configurar-permissoes/incluir-permissao-user/incluir-permissao-user.component";
import { UserPermGroupDialogComponent } from "./components/dialog/user-perm-group-dialog/user-perm-group-dialog.component";
import { NodeEditDialogComponent } from "./components/dialog/node-edit-dialog/node-edit-dialog.component";
import { EditAspectoComponent } from "./components/edit-aspectos/edit-aspecto.component";
import { EditPropertiesComponent } from "./components/edit-properties/edit-properties.component";
import { EditPropertieDialogComponent } from "./components/dialog/edit-propertie-dialog/edit-propertie-dialog.component";
import { EditAspectDialogComponent } from "./components/dialog/edit-aspect-dialog/edit-aspect-dialog.component";
import { SavePropertieDialogComponent } from "./components/dialog/edit-propertie-dialog/save-propertie-dialog/save-propertie-dialog.component";
import { ManterModelComponent } from "./importar-modelo/manter-model/manter-model.component";
import { CriarAspectosComponent } from "./vincular-tipo-cliente/criar-aspectos/criar-aspectos.component";
import { ManterAspectComponent } from "./components/manter-aspect/manter-aspect.component";
import { TemporalidadeComponent } from "./temporalidade/temporalidade.component";
import { TemporalidadeServiceService } from "./temporalidade/temporalidade-service.service";
import { ImportMatrizComponent } from "./components/import-matriz/import-matriz.component";
import { GlobalHelpDialogComponent } from "./components/dialog/global-help-dialog/global-help-dialog.component";
import { BuscarExpurgoComponent } from "./components/caixa/buscarExpurgo/buscarExpurgo.component";
import { ValidateCodeComponent } from "./components/validate-code/validate-code.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatStepperModule } from "@angular/material/stepper";

import { MatCardModule } from "@angular/material/card";
import { NotificacaoComponent } from "./components/notificacao/notificacao/notificacao.component";
import { NotificacaoDialogComponent } from "./components/notificacao/notificacao-dialog/notificacao-dialog.component";
import { NotificacaoService } from "./service/notificacao/notificacao.service";
import { IndicarConteudoDialogComponent } from "./components/solicitacao/indicar-conteudo-dialog/indicar-conteudo-dialog.component";
import { RequisitarConteudoComponent } from "./components/solicitacao/requisitar-conteudo/requisitar-conteudo.component";
import { MatSelectModule } from "@angular/material/select";
import { DevolverConteudoComponent } from "./components/solicitacao/devolver-conteudo/devolver-conteudo.component";
import { AppsService } from "./service/apps/apps.service";
import { AllVersionsInfoComponent } from "./components/versions/all-versions-info/all-versions-info.component";
import { VersionsInfoComponent } from "./components/versions/versions-info/versions-info.component";
import { VersionsInfoModalComponent } from "./components/versions/versions-info-modal/versions-info-modal.component";
import { HeaderNavComponent } from "./components/layout/header-nav/header-nav.component";
import { GlobalService } from "./service/global/global.service";
import { MatFormFieldModule } from "@angular/material/form-field";
import { NumeracaoCaixasComponent } from './components/caixa/gerar-numeracao/numeracao-caixas/numeracao-caixas.component';
import { ListarNumerosCaixasComponent } from './components/solicitacao/adicionar-solicitacao/listar-numeros/listar-numeros-caixas/listar-numeros-caixas.component';
import { GerenciarProtocoloComponent } from './components/solicitacao/gerenciar-protocolo/gerenciar-protocolo/gerenciar-protocolo.component';
import { ConfigurarContainerComponent } from './components/solicitacao/adicionar-solicitacao/configurar-container/configurar-container/configurar-container.component';

const appRoutes: Routes = [
  // AuthGuardEcm
  // canActivate: [ AuthGuard ]
  {
    path: "",
    component: LoginComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "validate-code",
    component: ValidateCodeComponent,
  },
  {
    path: "documentlist",
    component: DocumentlistComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "home",
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "lista-clientes",
    component: ListaclientesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cliente/:id",
    component: ClientesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "clientes",
    component: IndexComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tipo-cliente",
    component: TipoclienteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "app-versions-info",
    component: AllVersionsInfoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "ramo-atividade",
    component: RamoatividadeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "grupo-cliente",
    component: GrupoclienteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "indice-reajuste",
    component: IndicereajusteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tipo-reajuste",
    component: TiporeajusteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "centro-custo",
    component: CentroCustoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "armazem",
    component: ArmazemComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tipo-endereco",
    component: TipoenderecoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "regiao",
    component: RegiaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "pagination",
    component: PaginationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "grupo-produto",
    component: GrupoProdutoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "produto",
    component: ProdutoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dialog-confirm",
    component: DialogConfirmComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "adicionar-cliente",
    component: NovoClienteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "editar-cliente/:id",
    component: CreateClienteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "caixas",
    component: CaixaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "editar-caixa/:id",
    component: EditarCaixaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "codigo-alternativo",
    component: DialogCodAlternativoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "listar-caixas",
    component: ListarCaixaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "auditoria-caixa",
    component: AuditoriaCaixaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "pesquisa-avancada-caixa/:id",
    component: PesquisaCaixaAvancadaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "listar-conteudos",
    component: ListarConteudosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "pesquisa-avancada-conteudo/:id",
    component: PesquisaConteudoAvancadaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "exibir-conteudo",
    component: ExibirConteudoCaixaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tipo-caixa",
    component: TipoCaixaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tipo-conteudo",
    component: TipoConteudoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "incluir-conteudo/:id",
    component: AdicionarConteudoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "vincular-empresa",
    component: PermissaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "403",
    component: Erro403Component,
  },
  {
    path: "404",
    component: Erro404Component,
  },
  {
    path: "permissao/:id",
    component: ConfigurarPermissaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "grupo-permissao",
    component: GrupoPermissaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "criar-grupo-permissao",
    component: CreateGrupoPermissionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "editar-grupo-permissao/:id",
    component: CreateGrupoPermissionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "vincular-empresa",
    component: VincularEmpresaDialogComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "listagem-usuarios-permissao",
    component: ListagemPermissoesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "configurar-permissao/:id",
    component: ConfigurarPermissoesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "listagem-configurar-pasta",
    component: ListaClientesPastaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "config-parameters",
    component: ConfigParamsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "configurar-pasta/:id",
    component: ConfigurarPastaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "configurar-relatorio/:id",
    component: ConfigRelatorioComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "configurar-tipo-cliente/:id",
    component: VincularTipoClienteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "vincular-uri-alfresco",
    component: VincularUriAlfrescoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "importar-modelo",
    component: ImportarModeloComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "listagem-conteudo-eletronico",
    component: ListagemConteudoEletronicoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "view-conteudo-eletronico/:nodeId",
    component: ViewDocumentoEletronicoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "relatorio-caixa/:id",
    component: RelatorioCaixaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "relatorio-caixas/:ids/:empresa",
    component: RelatorioCaixasSelecionadasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "relatorio-solicitacao/:id",
    component: RelatorioSolicitacaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "relatorio-caixas-pendente-recuperacao",
    component: RelatorioPendenteRecuperacaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "relatorio-auditoria-caixa/:id",
    component: RelatorioAuditoriaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "relatorio-controle/:id/:tipo",
    component: RelatorioControleComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "imprimir-controle",
    component: ImprimirControleComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "adicionar-solicitacao",
    component: AdicionarSolicitacaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "solicitacao/:id",
    component: ListarSolicitacaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "solicitacoes",
    component: ListarSolicitacoesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "controle",
    component: ControleComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "pesquisa-avancada-solicitacao/:id",
    component: PesquisaAvancadaSolicitacaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "processar-solicitacao/:id",
    component: ProcessarSolicitacaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "recuperar-caixas",
    component: RecuperarCaixasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "devolver-caixas",
    component: DevolverCaixasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "modulo",
    component: ModuloComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tipo-componente",
    component: TipoComponenteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "unidade",
    component: UnidadeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "componentes",
    component: ComponenteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "detalhes-solicitacao",
    component: DetalhesSolicitacaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "componentes-filhos",
    component: ComponentesFilhosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "add-componente",
    component: AdicionarComponenteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "gerar-rgs",
    component: GerarRgsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "listar-rgs",
    component: ListaRgsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "grafico-alocacao",
    component: GraficoAlocacaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dados-autoria/:id",
    component: DadosAutoriaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "relatorio-solicitacao-realocacao/:id",
    component: RelatorioSolicitacaoRealocacaoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dados-arquivisticos/:clienteId/:tipoId",
    component: DadosArquivisticosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "token-assinador/:clienteId",
    component: TokenAssinadorComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dados-pessoais",
    component: DadosPessoaisComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "set-users-by-documental-type/:clienteId",
    component: UsersDocTypeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "incluir-permissao-user",
    component: IncluirPermissaoUserComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "edit-aspectos/:clienteId/:tipoId",
    pathMatch: "full",
    component: EditAspectoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "edit-aspectos/:tipoId",
    pathMatch: "full",
    component: EditAspectoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "edit-types",
    component: EditGlobalTypesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "edit-properties/:clienteId/:tipoId",
    component: EditPropertiesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "edit-properties/:tipoId",
    pathMatch: "full",
    component: EditPropertiesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "adicionar-propriedade/:clienteId/:tipoId",
    pathMatch: "full",
    component: SavePropertieDialogComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "adicionar-propriedade/:tipoId",
    pathMatch: "full",
    component: SavePropertieDialogComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "manter-modelo",
    component: ManterModelComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "criar-aspecto",
    component: CriarAspectosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "criar-relatorio/:id",
    component: CriarRelatorioComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "manter-aspecto/:id",
    component: ManterAspectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "manter-aspectos",
    component: ManterAspectComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "temporalidade/:id",
    component: TemporalidadeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "import-matriz/:clientId",
    component: ImportMatrizComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "relatorio-eliminacao",
    component: BuscarExpurgoComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "tabela-matriz/:clientId",
    component: TabelaMatrizComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "aspecto-propriedade/:clientId",
    component: CadastroAspectoPropriedadeComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "vincular-aspecto-propriedade/:clientId",
    component: VincularAspectoPontoAcessoComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "notificacoes",
    component: NotificacaoComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "notificacoes-dialog",
    component: NotificacaoDialogComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "indicar-conteudo-dialog",
    component: IndicarConteudoDialogComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "requisitar-conteudo",
    component: RequisitarConteudoComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "devolver-conteudo",
    component: DevolverConteudoComponent,
    pathMatch: "full",
    canActivate: [AuthGuard],
  },
  {
    path: "gerar-nrs",
    component: NumeracaoCaixasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "listar-nrs",
    component: ListarNumerosCaixasComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "gerenciar-protocolo",
    component: GerenciarProtocoloComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "configurar-container",
    component: ConfigurarContainerComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    MatCardModule,
    FormModule,
    MatExpansionModule,
    TextMaskModule,
    FormsModule,
    BrowserModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    NgxLoadingModule,
    MatStepperModule,
    TreeModule.forRoot(),
    MatPaginatorModule,
    MatTableModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    RouterModule.forRoot(
      appRoutes // ,
      // { enableTracing: true } // <-- debugging purposes only
    ),

    // ADF modules
    AdfModule,
    MatIconModule,
  ],
  declarations: [
    LocalDateTimePipe,
    LocalDateTimePipe2,
    LocalDateTimePipe3,
    LocalDateTimePipeAuditoria,
    LocalDateTimestamp,
    localDateTimePipe4,
    AppComponent,
    HomeComponent,
    LoginComponent,
    DocumentlistComponent,
    IndexComponent,
    EnderecosComponent,
    AreasComponent,
    ClientesComponent,
    TipoclienteComponent,
    RamoatividadeComponent,
    GrupoclienteComponent,
    IndicereajusteComponent,
    TiporeajusteComponent,
    ListaclientesComponent,
    RegiaoComponent,
    TipoenderecoComponent,
    ArmazemComponent,
    PaginationComponent,
    DialogTipoClienteComponent,
    CreateClienteComponent,
    GrupoProdutoComponent,
    ProdutoComponent,
    SidenavComponent,
    ProdutosArquivadosComponent,
    PaginationPrecoComponent,
    PrecoPadraoComponent,
    PrecificacaoComponent,
    UnidadeGestoraComponent,
    CentroCustoComponent,
    SidenavCaixaComponent,
    CaixaComponent,
    AssinaturaEletronicaComponent,
    TipoCaixaComponent,
    PermissaoComponent,
    AccessControlDirective,
    Erro403Component,
    Erro404Component,
    ConfigurarPermissaoComponent,
    GrupoPermissaoComponent,
    CreateGrupoPermissionComponent,
    VincularEmpresaDialogComponent,
    ListagemPermissoesComponent,
    ConfigurarPermissoesComponent,
    NovoClienteComponent,
    ListaClientesPastaComponent,
    ConfigurarPastaComponent,
    VincularTipoClienteComponent,
    IncluirTipoDocumentalComponent,
    EditarAspectoComponent,
    IncluirUriAlfrescoComponent,
    VincularUriAlfrescoComponent,
    VincularUriAlfrescoDialogComponent,
    ImportarModeloComponent,
    IncludeUniquePermissionComponent,
    ListarCaixaComponent,
    DialogCodAlternativoComponent,
    TipoConteudoComponent,
    AdicionarConteudoComponent,
    DialogConfirmComponent,
    EditarCaixaComponent,
    PesquisaCaixaAvancadaComponent,
    PesquisaConteudoAvancadaComponent,
    ListarConteudosComponent,
    ExibirConteudoCaixaComponent,
    ListagemConteudoEletronicoComponent,
    ViewDocumentoEletronicoComponent,
    RelatorioCaixaComponent,
    RelatorioCaixasSelecionadasComponent,
    SidenavSolicitacaoComponent,
    AdicionarSolicitacaoComponent,
    ListarSolicitacaoComponent,
    AuditoriaCaixaComponent,
    ListarSolicitacoesComponent,
    PesquisaAvancadaSolicitacaoComponent,
    ProcessarSolicitacaoComponent,
    DetalhesCaixaComponent,
    MultiplasOpcoesDialogComponent,
    AlocarRecipienteDialogComponent,
    ModuloComponent,
    TipoComponenteComponent,
    UnidadeComponent,
    ComponenteComponent,
    ComponentesFilhosComponent,
    AdicionarComponenteComponent,
    GerarRgsComponent,
    RelatorioSolicitacaoComponent,
    GraficoAlocacaoComponent,
    RecuperarCaixasComponent,
    DevolverCaixasComponent,
    ListaRgsComponent,
    RelatorioPendenteRecuperacaoComponent,
    RelatorioAuditoriaComponent,
    GraficoComponenteDialogComponent,
    ControleComponent,
    ImprimirControleComponent,
    RelatorioControleComponent,
    DetalhesSolicitacaoComponent,
    DadosAutoriaComponent,
    RelatorioSolicitacaoRealocacaoComponent,
    DadosArquivisticosComponent,
    TokenAssinadorComponent,
    ConfigRelatorioComponent,
    CriarRelatorioComponent,
    HeaderComponent,
    DadosPessoaisComponent,
    UsersDocTypeComponent,
    NodeUserDialogComponent,
    ConfigParamsComponent,
    ParamGroupDialogComponent,
    ParamTypeDialogComponent,
    IncluirPermissaoUserComponent,
    UserPermGroupDialogComponent,
    NodeEditDialogComponent,
    EditAspectoComponent,
    EditPropertiesComponent,
    EditPropertieDialogComponent,
    EditAspectDialogComponent,
    SavePropertieDialogComponent,
    ManterModelComponent,
    CriarAspectosComponent,
    ManterAspectComponent,
    EditGlobalTypesComponent,
    TemporalidadeComponent,
    ImportMatrizComponent,
    TabelaMatrizComponent,
    GlobalHelpDialogComponent,
    BuscarExpurgoComponent,
    ValidateCodeComponent,
    CadastroAspectoPropriedadeComponent,
    VincularAspectoPontoAcessoComponent,
    NotificacaoComponent,
    NotificacaoDialogComponent,
    IndicarConteudoDialogComponent,
    RequisitarConteudoComponent,
    DevolverConteudoComponent,
    AllVersionsInfoComponent,
    VersionsInfoComponent,
    VersionsInfoModalComponent,
    HeaderNavComponent,
    NumeracaoCaixasComponent,
    ListarNumerosCaixasComponent,
    GerenciarProtocoloComponent,
    ConfigurarContainerComponent,
  ],
  entryComponents: [
    IncluirTipoDocumentalComponent,
    EditarAspectoComponent,
    IncluirUriAlfrescoComponent,
    VincularUriAlfrescoDialogComponent,
    IncludeUniquePermissionComponent,
    DetalhesCaixaComponent,
    MultiplasOpcoesDialogComponent,
    AlocarRecipienteDialogComponent,
    GraficoComponenteDialogComponent,
    NodeUserDialogComponent,
    ParamGroupDialogComponent,
    ParamTypeDialogComponent,
    UserPermGroupDialogComponent,
    NodeEditDialogComponent,
    EditPropertieDialogComponent,
    EditAspectDialogComponent,
    SavePropertieDialogComponent,
    ManterModelComponent,
    CriarAspectosComponent,
    ManterAspectComponent,
    GlobalHelpDialogComponent,
    CriarRelatorioComponent,
    VersionsInfoModalComponent,
  ],

  providers: [
    {
      provide: MatDialogRef,
      useValue: {},
    },
    AccessControlDirective,
    LoginComponent,
    LocalDateTimePipe,
    LocalDateTimePipe3,
    localDateTimePipe4,
    DocmentlistService,
    ClienteService,
    ClienteService,
    AreaService,
    UnidadeGestoraService,
    EnderecoService,
    TipoclienteService,
    GrupoclienteService,
    IndicereajusteService,
    TiporeajusteService,
    RamoatividadeService,
    RegiaoService,
    ArmazemService,
    TipoenderecoService,
    GrupoProdutoService,
    ProdutoService,
    PrecoService,
    AplicabilidadeService,
    PrecoProdutoClienteService,
    CentroCustoService,
    TipoCaixaService,
    CaixaService,
    PermissoesService,
    AuthGuard,
    PermissionsService,
    ConfigurarPastaServiceService,
    TipoConteudoService,
    ConteudoService,
    ConteudoEletronicoService,
    SolicitacaoService,
    ModuloService,
    TipoComponenteService,
    UnidadeService,
    ComponenteService,
    CacheCodAlternativoService,
    DadosAutoriaService,
    DadosArquivisticosService,
    TokenAssinadorService,
    RelatorioService,
    DadosPessoaisService,
    ParamsService,
    TemporalidadeServiceService,
    BuscarExpurgoService,
    SecurityProfileService,
    NotificacaoService,
    AppsService,
    GlobalService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /app/src/app/app.module.ts